var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVppaOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 61 61",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "vppaOne"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30.252,
    cy: 30.126,
    r: 29.946,
    style: {
      fill: "#4888ad"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16.651,36.228l-0.113,11.527l28.61,-0l0,-30.077l-7.653,-7.712l-20.957,-0",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.536,9.975l0.052,7.549l7.6,0.067m0.012,-0.048l-7.643,-7.568",
    style: {
      fill: "#006de2"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M24.481,24.805c1.046,-0.046 1.768,-0.404 2.165,-1.073c0.208,-0.343 0.312,-0.741 0.312,-1.193c0,-0.715 -0.281,-1.258 -0.844,-1.63c-0.324,-0.218 -0.869,-0.424 -1.633,-0.618l-0,4.514Zm-3.111,-8.281c-0,0.566 0.2,1.01 0.601,1.33c0.401,0.32 0.94,0.543 1.619,0.669l0,-4.033c-0.801,0.029 -1.371,0.258 -1.711,0.687c-0.34,0.429 -0.509,0.878 -0.509,1.347Zm-1.652,0.103c-0,-0.87 0.341,-1.654 1.023,-2.351c0.682,-0.698 1.638,-1.053 2.868,-1.064l-0,-1.142l0.872,0l-0,1.124c1.217,0.08 2.151,0.417 2.803,1.009c0.652,0.592 0.993,1.374 1.023,2.347l-1.606,-0c-0.043,-0.435 -0.168,-0.81 -0.376,-1.125c-0.385,-0.577 -1,-0.881 -1.844,-0.909l-0,4.17c1.419,0.372 2.382,0.721 2.89,1.047c0.826,0.538 1.239,1.333 1.239,2.386c0,1.521 -0.529,2.603 -1.588,3.243c-0.587,0.355 -1.434,0.59 -2.541,0.704l-0,1.665l-0.872,-0l-0,-1.665c-1.78,-0.109 -2.989,-0.698 -3.625,-1.768c-0.349,-0.578 -0.523,-1.358 -0.523,-2.342l1.624,-0c0.049,0.783 0.181,1.355 0.395,1.716c0.379,0.646 1.083,1.01 2.11,1.09l0,-4.677c-1.321,-0.235 -2.297,-0.626 -2.927,-1.176c-0.63,-0.549 -0.945,-1.31 -0.945,-2.282Z",
    style: {
      fill: "#4888ad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.06,32.969l17.67,-8.846",
    style: {
      fill: "none",
      stroke: "#4888ad",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M23.661,35.815c1.117,-0 1.984,0.275 2.6,0.826c0.617,0.55 0.959,1.175 1.028,1.876l-1.166,-0c-0.132,-0.532 -0.395,-0.953 -0.79,-1.264c-0.394,-0.311 -0.948,-0.466 -1.66,-0.466c-0.869,-0 -1.571,0.285 -2.106,0.856c-0.534,0.571 -0.802,1.447 -0.802,2.626c0,0.966 0.242,1.75 0.724,2.351c0.483,0.601 1.202,0.901 2.16,0.901c0.88,0 1.551,-0.316 2.012,-0.949c0.244,-0.333 0.426,-0.771 0.546,-1.314l1.166,-0c-0.104,0.868 -0.449,1.597 -1.033,2.185c-0.701,0.707 -1.646,1.061 -2.836,1.061c-1.025,0 -1.886,-0.29 -2.583,-0.87c-0.917,-0.768 -1.375,-1.953 -1.375,-3.556c-0,-1.217 0.344,-2.215 1.033,-2.994c0.745,-0.846 1.772,-1.269 3.082,-1.269Z",
    style: {
      fill: "#4888ad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.635,35.815c1.557,-0 2.711,0.468 3.459,1.404c0.585,0.73 0.877,1.665 0.877,2.803c0,1.232 -0.334,2.256 -1.003,3.072c-0.785,0.959 -1.904,1.438 -3.358,1.438c-1.357,0 -2.424,-0.419 -3.201,-1.258c-0.693,-0.809 -1.039,-1.831 -1.039,-3.067c-0,-1.116 0.296,-2.07 0.889,-2.864c0.761,-1.019 1.886,-1.528 3.376,-1.528Zm0.12,7.718c1.053,-0 1.815,-0.353 2.285,-1.059c0.471,-0.706 0.706,-1.518 0.706,-2.435c-0,-0.97 -0.271,-1.751 -0.814,-2.342c-0.543,-0.592 -1.284,-0.888 -2.225,-0.888c-0.913,0 -1.658,0.293 -2.235,0.879c-0.577,0.586 -0.865,1.45 -0.865,2.592c0,0.914 0.247,1.684 0.742,2.312c0.495,0.627 1.296,0.941 2.406,0.941Z",
    style: {
      fill: "#4888ad",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.842,44.291c0.04,-0.693 0.194,-1.296 0.46,-1.809c0.266,-0.513 0.786,-0.979 1.559,-1.398l1.153,-0.624c0.516,-0.281 0.879,-0.52 1.087,-0.719c0.328,-0.311 0.493,-0.666 0.493,-1.067c-0,-0.468 -0.151,-0.84 -0.451,-1.115c-0.3,-0.275 -0.701,-0.413 -1.201,-0.413c-0.741,0 -1.254,0.262 -1.538,0.786c-0.152,0.281 -0.236,0.671 -0.252,1.169l-1.099,-0c0.012,-0.7 0.15,-1.272 0.414,-1.713c0.469,-0.779 1.295,-1.169 2.481,-1.169c0.985,0 1.705,0.249 2.159,0.747c0.455,0.498 0.682,1.053 0.682,1.663c-0,0.644 -0.242,1.194 -0.727,1.651c-0.28,0.266 -0.783,0.588 -1.508,0.966l-0.822,0.427c-0.393,0.203 -0.701,0.395 -0.926,0.579c-0.4,0.326 -0.652,0.687 -0.756,1.084l4.697,-0l-0,0.955l-5.905,-0Z",
    style: {
      fill: "#4888ad",
      fillRule: "nonzero"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVppaOne);
export default __webpack_public_path__ + "static/media/vppaOne.bb7bdb1ab6381fe5f1e675e69caf76c1.svg";
export { ForwardRef as ReactComponent };